// 이미 완성된 발송 원문(content)을 그대로 보여줄 때 쓰는 범용 카카오 알림톡 카드 —
// 문구는 서버가 결정한다(미리보기: Hermes 렌더 API, 이력: 접수 시 서버가 저장한 본문). 화면은 문구를 조립하지 않는다.
export interface KakaoMessageCardProps {
  content: string
  /** 하단 버튼 라벨 — 승인 템플릿의 실제 버튼 그대로(예: FOREMAN_CONFIRM은 "일정가능"/"일정불가능" 2개) */
  buttons: string[]
}

export function KakaoMessageCard({ content, buttons }: KakaoMessageCardProps) {
  return (
    <div style={{ borderRadius: 16, overflow: 'hidden', border: '1px solid var(--shell-border)' }}>
      <div style={{ background: 'var(--brand-kakao-symbol)', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ fontSize: 20, lineHeight: 1 }}>💬</div>
        <div>
          <div style={{ fontSize: 9.5, color: 'var(--brand-kakao-container)', letterSpacing: '.4px' }}>카카오 알림톡</div>
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--shell-surface)' }}>인디피아</div>
        </div>
      </div>
      <div style={{ background: 'var(--shell-surface)', padding: '14px 14px', fontSize: 12, lineHeight: 1.7, color: 'var(--shell-on-surface)', whiteSpace: 'pre-line' }}>
        {content}
      </div>
      {buttons.length > 0 && (
        <div style={{ display: 'flex', borderTop: '1px solid var(--shell-border)', background: 'var(--shell-surface)' }}>
          {buttons.map((label, i) => (
            <div key={label} style={{ flex: 1, padding: '11px 0', textAlign: 'center', fontSize: 12, fontWeight: 600, color: 'var(--shell-on-surface)', borderLeft: i > 0 ? '1px solid var(--shell-border)' : undefined }}>
              {label}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
